import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview as InvitesOverview } from 'domains/MediaPlatforms/Spaces/Space/Permissions/Invites'
import { Overview as TeamsOverview } from 'domains/MediaPlatforms/Spaces/Space/Permissions/Teams'
import { Overview as UsersOverview } from 'domains/MediaPlatforms/Spaces/Space/Permissions/Users'
import { mediaPlatformSpaceLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Routing'

export const mediaPlatformSpacePermissionsRoute = createRoute({
  getParentRoute: () => mediaPlatformSpaceLayoutRoute,
  path: StaticRouteParameter.PERMISSIONS,
  loader: () => null,
})

type MediaPlatformSpacePermissionsUsersSearch = {
  query?: string
}

export const mediaPlatformSpacePermissionsUsersOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacePermissionsRoute,
  path: '/',
  component: UsersOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSpacePermissionsUsersSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type MediaPlatformSpacePermissionsTeamsSearch = {
  query?: string
}

export const mediaPlatformSpacePermissionsTeamsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacePermissionsRoute,
  path: StaticRouteParameter.TEAMS,
  component: TeamsOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSpacePermissionsTeamsSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type MediaPlatformSpacePermissionsInvitesSearch = {
  query?: string
}

export const mediaPlatformSpacePermissionsInvitesOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacePermissionsRoute,
  path: StaticRouteParameter.INVITATIONS,
  component: InvitesOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSpacePermissionsInvitesSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
